import React from 'react';
import { InvoiceExportPlugins } from '../components';

export default () => {
    return (
        <InvoiceExportPlugins.Home />
    )
}